var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFile = function SvgFile(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 35,
    fill: "none",
    viewBox: "0 0 31 35",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212123",
    strokeWidth: 1.31,
    d: "M27.935 10.789V31.48a2.07 2.07 0 0 1-2.07 2.07H5.176a2.07 2.07 0 0 1-2.07-2.07V6.651a2.07 2.07 0 0 1 2.07-2.07h16.553m6.207 6.208-6.207-6.207m6.207 6.207H22.33a.603.603 0 0 1-.602-.603V4.582"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#212123",
    strokeLinecap: "round",
    strokeWidth: 1.31,
    d: "M8.871 16.849h7.094M8.871 21.283h12.415M8.871 25.716h12.415M8.87 8.203v.665c0 .98.793 1.773 1.773 1.773v0c.98 0 1.773-.794 1.773-1.773V2.66c0-.98-.794-1.773-1.773-1.773v0c-.98 0-1.774.794-1.774 1.773v1.478"
  })));
};
export default SvgFile;